module.exports = __webpack_public_path__ + "img/ic-ic-talktalk.58c62dab.svg";